import ChatIconWithBadge from './ChatIconWithBadge';

export default ChatIconWithBadge;
